import { ClickAwayListener, IconButton } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import React from "react";
import { Info } from "react-feather";

const TreffasTooltip = ({ title, customStyle = {} }) => {
  const [open, setOpen] = React.useState(false);

  const onClose = () => {
    setOpen(false);
  };

  const onOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <ClickAwayListener onClickAway={onClose}>
        <div>
          <Tooltip
            onClose={onClose}
            onMouseEnter={onOpen}
            onMouseLeave={onClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={title}
            arrow
            PopperProps={{
              disablePortal: true,
              sx: {
                [`& .${tooltipClasses.arrow}`]: {
                  color: "#E8F0FF",
                },
                [`& .${tooltipClasses.tooltip}`]: {
                  maxWidth: "407px",
                  backgroundColor: "#E8F0FF",
                  borderRadius: "8px",
                  color: "var(--color-black)",
                  fontWeight: 500,
                  fontSize: "14px !important",
                  lineHeight: "20px",
                  p: "12px",
                  whiteSpace: "pre-line",
                },
                fontFamily: `var(--font-${customStyle?.bodyFont})`,
              },
            }}
          >
            <IconButton onClick={onOpen}>
              <Info
                size={16}
                color={customStyle?.accentColor ?? "var(--color-black)"}
              />
            </IconButton>
          </Tooltip>
        </div>
      </ClickAwayListener>
    </>
  );
};

export default TreffasTooltip;
